import { useStore } from '@/utils/useStore'
import ToastsStore from '@/store/toasts'
import UsersStore from '@/store/users'
import { organizationEditAPI, organizationGetMineAPI } from '~/api/organization'
import { sentimentsFollowOrganizationAPI } from '~/api/sentiments'
import UserStore from '@/store/user'
import { OrganizationStatus } from '~/classes/Organization'

export default defineStore('organizations', () => {
  const { getItem, getItems, setItem, deleteItem } = useStore('organization')

  const usersStore = UsersStore()
  const userStore = UserStore()
  const { followingOrganizations } = storeToRefs(userStore)

  const currentOrganizationId = ref('')
  const currentOrganization = computed(() => currentOrganizationId.value ? getItem(currentOrganizationId.value) : null)

  const initOrganization = async () => {
    const lastOrganizationId = await getCookie('organization') as string

    await getMine()

    if (lastOrganizationId) {
      const organization = getItem(lastOrganizationId)

      if (organization) {
        currentOrganizationId.value = lastOrganizationId
      }
    }
  }

  const selectOrganization = async (organizationId: string) => {
    const organization = getItem(organizationId)

    if (organization) {
      await setCookie('organization', organizationId, {
        isGlobal: true
      })

      currentOrganizationId.value = organizationId
    }
  }

  const getMine = async () => {
    const response = await organizationGetMineAPI()

    if (response.ok) {
      if (response.data.users) response.data.users.forEach((user) => usersStore.setItem(user))

      return response.data.organizations.map((o) => {
        setItem(o)
        return o._id
      })

    }

    return []
  }

  const edit = async (organizationId: string, params: {
    name?: string
    description?: string
    logo?: string
    banner?: string
    status?: typeof OrganizationStatus[number]
    isCertified?: boolean
    isVerified?: boolean
  }) => {
    const response = await organizationEditAPI(organizationId, params)

    if (response.ok) {
      setItem(response.data.organization)
    }

    return true
  }

  const follow = async (
    organizationId: string,
    action?: 'follow' | 'unfollow'
  ) => {
    const response = await sentimentsFollowOrganizationAPI(organizationId, action ?? 'follow')

    if (response.ok) {
      if (response.data.following) followingOrganizations.value = response.data.following
    }

    return true
  }

  return {
    setItem, deleteItem, getMine, selectOrganization, currentOrganization, currentOrganizationId, initOrganization, edit,
    getItems, getItem, follow
  }
})